<template>
  <div class="pageContainer">
    <md-content>
      <div class="md-layout-item md-size-100">
        <h1>Account codes</h1>

        <form @submit.prevent="fetchAccountCodes">
          <md-field 
            :class="$v.form.code.$error && 'md-invalid'"
          >
            <label>Generated group name</label>
            <md-input v-model="form.code" />
            <span class="md-error">Required field</span>
          </md-field>

          <md-field 
            :class="$v.form.accounts_count.$error && 'md-invalid'"
          >
            <label>Accounts count</label>
            <md-input
              v-model="form.accounts_count"
              type="number"
            />
            <span class="md-error">Required field, more than 0</span>
          </md-field>

          <div class="calendar-wrapper">
            <div>
              <label>Starts</label>
              <md-datepicker
                v-model="form.start_from"
                md-immediately
                class="datepicker"
              />
              <div
                v-if="$v.form.start_from.$error"
                class="error-feedback"
              >
                Field is required
              </div>
            </div>
    
            <div>
              <label>Until</label>
              <md-datepicker
                v-model="form.valid_until"
                md-immediately
                class="datepicker"
              />
              <div
                v-if="$v.form.valid_until.$error"
                class="error-feedback"
              >
                Field is required
              </div>
            </div>
          </div>

          <md-switch v-model="form.with_device">
            With device
            <md-tooltip md-direction="bottom">
              <p>це означає чи генерувати акаунт з захардкодженим девайсом щоб були vpn creds</p>
            </md-tooltip>
          </md-switch>

          <br>

          <md-button type="submit">
            Generate
          </md-button>
        </form>
      </div>
    </md-content>

    <md-content v-if="result.isAvailable">
      <div class="md-layout-item md-size-100">
        <h5>Generation successful, click below to download:</h5>

        <md-button @click="downloadCSV">
          Download CSV
        </md-button>
      </div>
    </md-content> 

    <md-content v-else-if="error">
      <h5 style="color: red; padding: 12px">
        {{ error }}
      </h5>
    </md-content> 
  </div>
</template>
<script>
  import {required, numeric, minValue} from "vuelidate/lib/validators";

  const currentDate = new Date();

  const DAY_IN_MILLS = 24 * 60 * 60 * 1000;

  export default {
    data() {
      return {
        form: {
          code: "",
          start_from: currentDate,
          valid_until: new Date(currentDate.getTime() + DAY_IN_MILLS),
          accounts_count: 0,
          with_device: false,
        },

        result: {
          isAvailable: false,
          data: null,
        },
        error: null,
      };
    },
    methods: {
      fetchAccountCodes() {
        this.error = null;
        this.result = {
          isAvailable: false,
          data: null,
        };

        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }

        this.$http.post("/v1/admin/generate/anonymous-accounts", {
          code: this.form.code,
          start_from: this.form.start_from,
          valid_until: this.form.valid_until,
          accounts_count: Number.parseInt(this.form.accounts_count),
          count_days: Math.floor((this.form.valid_until - this.form.start_from) / DAY_IN_MILLS),
          with_device: this.form.with_device,
        }).then((response) => {
          this.result = {
            isAvailable: true,
            data: response.data.data.map(item => `"${item}"`).join("\n"),
          };
        }, error => {
          this.error = error.response.data.message || "Something went wrong";
        });
      },
      downloadCSV() {
        const element = document.createElement("a");
        element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(this.result.data));
        element.setAttribute("download", "account-codes.csv");

        element.style.display = "none";
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
        this.downloadCSVButton.isLoading = false;
      }
    },
    validations: {
      form: {
        code: {
          required,
        },
        accounts_count: {
          required,
          numeric,
          minValue: minValue(1),
        },
        start_from: {
          required,
        },
        valid_until: {
          required,
        },
      }
    }
  };
</script>
<style lang="scss" scoped>
  .pageContainer {
    max-width: 800px;
    padding: 20px;
  }

  .calendar-wrapper {
    display: flex;
    justify-content: space-between;

    & > div {
      width: 48%;
      margin-bottom: 5px;

      .error-feedback {
        margin-top: -20px;
      }
    }
  }
</style>
